module.exports = __webpack_public_path__ + "static/media/convert.b0bd8793.png";